import ArrowBack from "@mui/icons-material/ArrowBack";
import { Box, IconButton, Stack, Tab, Tabs, Typography } from "@mui/material";
import { useTenantTranslation } from "hooks/formatters";
import { useNumberSerialiser } from "hooks/serialisers/numbers";
import { useQueryParamState } from "hooks/useQueryParamState";
import { useState } from "react";
import { useNavigate, useParams } from "react-router";
import { CalendarTab } from "./CalendarTab";
import { LocationsTab } from "./LocationsTab";
import { LabellingCoverageGranularity } from "store/api/generatedApi";
import { CoverageControls } from "./CoverageControls";

export const TenantLabellingCoveragePage = () => {
  const { t } = useTenantTranslation();
  const navigate = useNavigate();
  const { tenantName } = useParams<{ tenantName: string }>();
  const numberSerialiser = useNumberSerialiser();
  const [tab, setTab] = useQueryParamState("tab", numberSerialiser, 0);
  const [gapTolerance, setGapTolerance] = useState(60);
  const [granularity, setGranularity] =
    useState<LabellingCoverageGranularity>("period");

  const handleTabChange = (_e: React.SyntheticEvent, newTab: number) => {
    setTab(newTab);
  };

  if (!tenantName) {
    return <Typography>{t("tenantNotFound")}</Typography>;
  }

  return (
    <Stack spacing={3} sx={{ p: 3, height: "100%", overflow: "auto" }}>
      <Stack direction="row" spacing={2} alignItems="center">
        <IconButton onClick={() => void navigate("..")}>
          <ArrowBack />
        </IconButton>
        <Typography variant="h4" sx={{ flex: 1 }}>
          {t("labellingCoverageFor")} {tenantName}
        </Typography>
        <CoverageControls
          granularity={granularity}
          onGranularityChange={setGranularity}
          gapTolerance={gapTolerance}
          onGapToleranceChange={setGapTolerance}
        />
      </Stack>

      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
        <Tabs value={tab} onChange={handleTabChange}>
          <Tab label={t("byLocation")} />
          <Tab label={t("calendar")} />
        </Tabs>
      </Box>

      {tab === 0 && (
        <LocationsTab
          tenantName={tenantName}
          gapTolerance={gapTolerance}
          granularity={granularity}
        />
      )}
      {tab === 1 && (
        <CalendarTab
          tenantName={tenantName}
          gapTolerance={gapTolerance}
          granularity={granularity}
        />
      )}
    </Stack>
  );
};
